import { useQuery } from '@tanstack/react-query';

import { overviewUserListTaskCheckKey } from './queryKeys';
import type { QueryParams } from '@/types/common/api.type';
import { overviewUserListTaskCheckService } from '@/services/rest';

export const useOverViewUserListTaskChecks = (params?: QueryParams) =>
    useQuery({
        queryKey: overviewUserListTaskCheckKey.list(params),
        queryFn: () => overviewUserListTaskCheckService().index(params),
        placeholderData: previousData => previousData,
    });
